const FALLBACK_DARK_TEXT = '#404040'
const FALLBACK_LIGHT_TEXT = '#ffffff'

const getReadableTextColor = (backgroundColor?: string) => {
  if (!backgroundColor) return FALLBACK_DARK_TEXT

  const hexMatch = backgroundColor.match(/#([0-9a-f]{3,8})/i)
  if (!hexMatch) return FALLBACK_DARK_TEXT

  let hex = hexMatch[1]
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(char => char + char)
      .join('')
  }
  if (hex.length < 6) return FALLBACK_DARK_TEXT

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)

  const toLinear = (value: number) => {
    const channel = value / 255
    return channel <= 0.03928
      ? channel / 12.92
      : Math.pow((channel + 0.055) / 1.055, 2.4)
  }

  const luminance =
    0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b)

  return luminance > 0.55 ? FALLBACK_DARK_TEXT : FALLBACK_LIGHT_TEXT
}

export default getReadableTextColor
